import { configureStore,combineReducers } from "@reduxjs/toolkit";
import LangSetReducer from "./LangSetReducer";
import LoginInfoReducer from "./LoginInfoReducer";
import PageSetReducer from "./PageSetReducer";
import IdntMthdCdSetReducer from "./IdntMthdCdReducer";

const  MgpStore = configureStore ( {
    reducer: {
        LangSetState:LangSetReducer,
        PageSetState:PageSetReducer,
        LoginInfoState:LoginInfoReducer,
        IdntMthdCdState:IdntMthdCdSetReducer
    }
});

export default MgpStore;